import { PasswordField } from './password'
import { PhoneInputController } from './phone'
import { PhoneInput } from './phone/types'
import { SelectField, SelectType } from './select'
import { ResetableTextField, TextField } from './text'
import { TextareaCounter } from './textarea'
import { DateInputMask } from './date'

export function initPhoneInputs(): void {
  document.querySelectorAll('[data-phone-input]').forEach((element) => {
    new PhoneInputController(element as PhoneInput).init()
  })
}

export function initDateInputs(): void {
  document
    .querySelectorAll<HTMLInputElement>(
      'input[data-type="date"]:not([data-date-input-initialized])'
    )
    .forEach((element) => {
      element.dataset.dateInputInitialized = 'true'
      new DateInputMask(element).init()
    })
}

export function initPasswordFields(): void {
  document.querySelectorAll('[data-password-field]').forEach((element) => {
    new PasswordField(element as HTMLElement)
  })
}

export function initTextFields(): void {
  document
    .querySelectorAll<HTMLInputElement>(
      '.text-field-counter .text-field:not([data-text-field-initialized])'
    )
    .forEach((element) => {
      element.dataset.textFieldInitialized = 'true'
      new TextField(element)
    })

  document
    .querySelectorAll<HTMLTextAreaElement>(
      '[data-textarea-counter-input]:not([data-textarea-counter-initialized])'
    )
    .forEach((element) => {
      element.dataset.textareaCounterInitialized = 'true'
      new TextareaCounter(element)
    })

  document
    .querySelectorAll<HTMLInputElement>(
      '[data-field-resetable]:not([data-field-reset-initialized])'
    )
    .forEach((element) => {
      element.dataset.fieldResetInitialized = 'true'
      new ResetableTextField(element)
    })
}

/**
 * Инициализирует все поля селекта на странице
 */
export const initSelectFields = (): void => {
  document
    .querySelectorAll<SelectType>('[data-select-field]')
    .forEach((element) => {
      new SelectField(element)
    })
}
